import styled from "styled-components";

import { stylesGlobalDefault } from "../../global/globalStyle";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerTitle = styled.div`
  margin-bottom: 10px;
  width: 100%;
  text-align: center;

  @media (max-width: 1600px) {
    margin-bottom: 1px;
  }
`;

export const ContainerBar = styled.div`
  margin: 10px 0;
  width: 100%;
  max-width: 380px;

  @media (max-width: 1600px) {
    margin: 4px 0;
  }
`;

export const ContainerDescription = styled.div`
  width: 100%;
  text-align: center;
`;

export const Button = styled.button`
  padding: 10px 15px;
  border: none;
  border-radius: 50px;
  font-weight: 500;
  outline: none;
  transition: all 0.2s;
  background-color: ${stylesGlobalDefault.blue};
  color: ${stylesGlobalDefault.white};
  border: 2px ${stylesGlobalDefault.blue} solid;
  cursor: pointer;
  margin-bottom: 5px;
  &:hover {
    border-color: ${stylesGlobalDefault.white};
    background-color: ${stylesGlobalDefault.blueDark};
    background: ${stylesGlobalDefault.blueDark};
  }
`;
